interface IGetAirbnb {
  id: string
}
export const getAirbnb = async (req: IGetAirbnb) => {
  const endpoint =
    "https://us-central1-polysleep-5290e.cloudfunctions.net/getListingInfo";
  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(req),
    })
    const data = await res.json()
    return data;
  } catch (e) {
    console.error(`getGooglePlace error ${e.message}`, e)
  }
};